import { PreviewResponse } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/utils";
import { PreviewList } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/TrainInfoModal/PreviewList";
import { FC } from "react";

export type PreviewStatus = "pending" | "success" | "error" | "idle";

type PreviewProps = {
  previewData: PreviewResponse | undefined;
  previewStatus: PreviewStatus;
};

export const Preview: FC<PreviewProps> = ({ previewData, previewStatus }) => (
  <PreviewList
    previewStatus={previewStatus}
    previewData={previewData ? [previewData] : []}
  />
);
